// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__JwxlW","footer":"ModalInfo_footer__21I1g"};